// Minimal i18n for Voix. English is the base; other languages fall back to EN
// when a key is missing.
export const LOCALES = {
  en: { label: "English", flag: "🇬🇧" },
  fr: { label: "Français", flag: "🇫🇷" },
  es: { label: "Español", flag: "🇪🇸" },
  pt: { label: "Português", flag: "🇵🇹" },
};

const en = {
  // Nav
  "nav.moods": "Moods",
  "nav.places": "Places",
  "nav.genres": "Genres",
  "nav.top": "Top Stations",
  "nav.favorites": "Favorites",
  "nav.recent": "Recent",
  "nav.tagline": "World · Radio · 24/7",

  // Sidebar
  "sidebar.search": "Search station name…",
  "sidebar.active_filters": "Active Filters",
  "sidebar.clear": "Clear",
  "sidebar.powered_by": "Powered by Radio Browser",
  "sidebar.footer_note": "No ads · No tracking · 100k+ stations",

  // Landing
  "landing.moods.pre": "How are you listening?",
  "landing.moods.title": "Pick a mood",
  "landing.moods.subtitle":
    "Curated shelves of live radio from across the globe. Tap a tile to explore stations — or hit the play button to hear one instantly.",
  "landing.timemachine.pre": "Time · Machine",
  "landing.timemachine.title": "Rewind by decade",
  "landing.genres.pre": "Every · genre · ever · tagged",
  "landing.genres.title": "Genres",
  "landing.genres.subtitle":
    "Every genre tag from the Radio Browser database. Click one to open the station wall.",
  "landing.places.pre": "Tune the world",
  "landing.places.title": "Pick a country",
  "landing.places.subtitle":
    "Spin the globe. Click any dot to load its live radio stations.",
  "landing.surprise": "Surprise me",

  // Moods
  "mood.late-night": "Late Night",
  "mood.morning": "Morning Wake",
  "mood.workout": "Workout",
  "mood.focus": "Focus",
  "mood.party": "Party",
  "mood.chill": "Chill",
  "mood.discovery": "Discovery",
  "mood.news": "News & Talk",

  // Views
  "view.top.pre": "Top · World",
  "view.top.main": "Most-Played Stations",
  "view.favorites.pre": "Your · Library",
  "view.favorites.main": "Favorites",
  "view.history.pre": "Recently · Tuned",
  "view.history.main": "Playback History",
  "view.search.pre": "Search",
  "view.search.type": "Type to search stations…",
  "view.search.results": "Results for",
  "view.mood.pre": "Mood",
  "view.decade.pre": "Time · Machine",
  "view.decade.suffix": "Radio",
  "view.filter.pre": "Stations",
  "view.back": "Back to",
  "view.tuning": "Tuning frequencies…",
  "view.stations": "station",
  "view.stations_plural": "stations",

  // Empty
  "empty.favorites.t": "No favorites yet",
  "empty.favorites.s": "Tap the heart on any station to save it.",
  "empty.history.t": "Nothing played yet",
  "empty.history.s": "Your recently tuned stations will appear here.",
  "empty.search.t": "Type to search",
  "empty.search.s": "Search stations by name from the sidebar.",
  "empty.filter.t": "No stations match",
  "empty.filter.s": "Try a different country, tag or language.",
  "empty.mood.t": "No stations found",
  "empty.mood.s": "Try another mood or open Places.",
  "empty.decade.t": "No stations found",
  "empty.decade.s": "Try another decade.",
  "empty.top.t": "No data available",
  "empty.top.s": "Radio Browser may be temporarily unreachable.",

  // Player
  "player.idle": "Idle",
  "player.pick": "Pick a station to begin",
  "player.on_air": "On Air",
  "player.paused": "Paused",
  "player.tuning": "Tuning…",
  "player.rec": "Rec",
  "player.eq": "EQ",
  "player.sleep": "Sleep",
  "player.alarm": "Alarm",
  "player.share": "Share",
  "player.fav": "Fav",

  // EQ
  "eq.title": "Graphic EQ",
  "eq.subtitle": "5-band · ±12dB",
  "eq.preset.flat": "flat",
  "eq.preset.bass": "bass",
  "eq.preset.vocal": "vocal",
  "eq.preset.club": "club",
  "eq.preset.radio": "radio",
  "eq.preset.treble": "treble",

  // Sleep
  "sleep.title": "Sleep Timer",
  "sleep.subtitle": "Fade-out · then · stop",
  "sleep.running": "Running",
  "sleep.cancel": "Cancel timer",
  "sleep.min": "min",
  "sleep.custom": "Custom (min)",
  "sleep.start": "Start",
  "sleep.ended": "Sleep timer ended · goodnight",

  // Alarm
  "alarm.title": "Alarm Clock",
  "alarm.subtitle": "Wake up · to radio",
  "alarm.time": "Time",
  "alarm.station": "Station",
  "alarm.station.current": "Current station",
  "alarm.station.pick_first": "Play any station first, then set alarm",
  "alarm.set": "Set alarm",
  "alarm.cancel": "Cancel alarm",
  "alarm.next": "Next alarm",
  "alarm.ringing": "Alarm · time to wake up",
  "alarm.set_toast": "Alarm set for {time}",

  // Stats
  "stats.pre": "Your · Listening · Map",
  "stats.title": "You've tuned to",
  "stats.countries": "countries this month",
  "stats.no_data": "Your listening map will appear here once you play a few stations.",

  "passport.title": "Voix Passport",
  "passport.subtitle": "Your monthly listening card",
  "passport.open": "My Passport",
  "passport.id": "ID",
  "passport.hours_label": "You listened for",
  "passport.hours_of_radio": "of world radio",
  "passport.top_countries": "Top countries",
  "passport.fav_mood": "Favorite mood",
  "passport.plays": "Plays",
  "passport.countries": "Countries",
  "passport.favorites": "Favorites",
  "passport.download": "Download",
  "passport.share": "Share",
  "passport.exporting": "Exporting…",
  "passport.downloaded": "Passport saved",
  "passport.export_failed": "Export failed",
  "passport.empty.title": "No passport yet",
  "passport.empty.subtitle": "Play a few stations to unlock your first monthly passport.",

  // Toasts
  "toast.added_fav": "Added to favorites",
  "toast.removed_fav": "Removed from favorites",
  "toast.share_copied": "Share link copied",
  "toast.rec_started": "Recording started",
  "toast.rec_saved": "Recording saved",
  "toast.rec_no_station": "Play a station first",
  "toast.rec_unsupported": "Recording unsupported in this browser",
  "toast.rec_failed": "Recording failed to start",
  "toast.stream_fail": "Cannot start stream. Trying to load…",
  "toast.no_url": "Station has no stream URL",
  "toast.disconnected": "Stream disconnected. Try another station.",
  "toast.no_random": "Couldn't tune in. Try another mood.",
  "toast.no_random_dec": "Couldn't tune the time machine.",
  "toast.no_random_global": "Couldn't pick a random station",
};

const fr = {
  "nav.moods": "Ambiances", "nav.places": "Lieux", "nav.genres": "Genres",
  "nav.top": "Top Stations", "nav.favorites": "Favoris", "nav.recent": "Récents",
  "nav.tagline": "Monde · Radio · 24/7",
  "sidebar.search": "Rechercher une station…",
  "sidebar.active_filters": "Filtres actifs",
  "sidebar.clear": "Effacer",
  "sidebar.powered_by": "Propulsé par Radio Browser",
  "sidebar.footer_note": "Sans pub · Sans traçage · 100k+ stations",
  "landing.moods.pre": "Comment écoutes-tu ?",
  "landing.moods.title": "Choisis une ambiance",
  "landing.moods.subtitle":
    "Étagères de radio en direct du monde entier. Touche une tuile pour explorer — ou joue-la instantanément.",
  "landing.timemachine.pre": "Machine · à · Remonter",
  "landing.timemachine.title": "Revenir par décennie",
  "landing.genres.pre": "Chaque · Genre · Étiqueté",
  "landing.genres.title": "Genres",
  "landing.genres.subtitle":
    "Chaque genre de la base Radio Browser. Clique pour ouvrir le mur de stations.",
  "landing.places.pre": "Accorde le monde",
  "landing.places.title": "Choisis un pays",
  "landing.places.subtitle":
    "Fais tourner le globe. Clique un point pour charger ses stations.",
  "landing.surprise": "Surprends-moi",
  "mood.late-night": "Nuit Tardive", "mood.morning": "Réveil Matin",
  "mood.workout": "Sport", "mood.focus": "Concentration",
  "mood.party": "Fête", "mood.chill": "Chill",
  "mood.discovery": "Découverte", "mood.news": "Info & Talk",
  "view.top.pre": "Top · Monde", "view.top.main": "Stations les plus écoutées",
  "view.favorites.pre": "Ta · Bibliothèque", "view.favorites.main": "Favoris",
  "view.history.pre": "Récemment · Écoutées", "view.history.main": "Historique",
  "view.search.pre": "Recherche", "view.search.type": "Écris pour chercher…",
  "view.search.results": "Résultats pour",
  "view.mood.pre": "Ambiance", "view.decade.pre": "Machine · à · Remonter",
  "view.decade.suffix": "Radio",
  "view.filter.pre": "Stations",
  "view.back": "Retour vers",
  "view.tuning": "Accord des fréquences…",
  "view.stations": "station", "view.stations_plural": "stations",
  "empty.favorites.t": "Aucun favori", "empty.favorites.s": "Touche un cœur pour enregistrer une station.",
  "empty.history.t": "Rien joué", "empty.history.s": "Tes stations écoutées apparaîtront ici.",
  "empty.search.t": "Écris pour chercher", "empty.search.s": "Cherche par nom depuis la barre latérale.",
  "empty.filter.t": "Aucune correspondance", "empty.filter.s": "Essaie un autre pays, tag ou langue.",
  "empty.mood.t": "Aucune station", "empty.mood.s": "Essaie une autre ambiance ou Lieux.",
  "empty.decade.t": "Aucune station", "empty.decade.s": "Essaie une autre décennie.",
  "empty.top.t": "Aucune donnée", "empty.top.s": "Radio Browser est peut-être injoignable.",
  "player.idle": "Repos", "player.pick": "Choisis une station",
  "player.on_air": "En Direct", "player.paused": "En Pause", "player.tuning": "Accord…",
  "player.rec": "Enr", "player.eq": "EQ", "player.sleep": "Sommeil", "player.alarm": "Réveil",
  "player.share": "Partager", "player.fav": "Fav",
  "eq.title": "Égaliseur", "eq.subtitle": "5 bandes · ±12dB",
  "sleep.title": "Minuteur de sommeil", "sleep.subtitle": "Fondu · puis · stop",
  "sleep.running": "En cours", "sleep.cancel": "Annuler",
  "sleep.min": "min", "sleep.custom": "Personnalisé (min)", "sleep.start": "Démarrer",
  "sleep.ended": "Minuteur terminé · bonne nuit",
  "alarm.title": "Réveil", "alarm.subtitle": "Se réveiller · à la radio",
  "alarm.time": "Heure", "alarm.station": "Station",
  "alarm.station.current": "Station actuelle",
  "alarm.station.pick_first": "Joue une station puis règle le réveil",
  "alarm.set": "Régler le réveil", "alarm.cancel": "Annuler le réveil",
  "alarm.next": "Prochain réveil", "alarm.ringing": "Réveil · debout",
  "alarm.set_toast": "Réveil réglé à {time}",
  "stats.pre": "Ta · Carte · d'Écoute", "stats.title": "Tu as écouté",
  "stats.countries": "pays ce mois-ci",
  "stats.no_data": "Ta carte apparaîtra après quelques écoutes.",
  "passport.title": "Passeport Voix", "passport.subtitle": "Ta carte d'écoute mensuelle",
  "passport.open": "Mon passeport", "passport.id": "ID",
  "passport.hours_label": "Tu as écouté", "passport.hours_of_radio": "de radio du monde",
  "passport.top_countries": "Top pays", "passport.fav_mood": "Ambiance préférée",
  "passport.plays": "Écoutes", "passport.countries": "Pays", "passport.favorites": "Favoris",
  "passport.download": "Télécharger", "passport.share": "Partager",
  "passport.exporting": "Export…", "passport.downloaded": "Passeport sauvegardé",
  "passport.export_failed": "Échec de l'export",
  "passport.empty.title": "Pas encore de passeport",
  "passport.empty.subtitle": "Joue quelques stations pour débloquer ton premier passeport mensuel.",
  "toast.added_fav": "Ajouté aux favoris", "toast.removed_fav": "Retiré des favoris",
  "toast.share_copied": "Lien copié", "toast.rec_started": "Enregistrement démarré",
  "toast.rec_saved": "Enregistrement sauvegardé",
  "toast.rec_no_station": "Joue d'abord une station",
  "toast.rec_unsupported": "Enregistrement non supporté", "toast.rec_failed": "Échec de l'enregistrement",
  "toast.stream_fail": "Impossible de démarrer le flux. Chargement…",
  "toast.no_url": "Cette station n'a pas d'URL",
  "toast.disconnected": "Flux déconnecté. Essaie une autre station.",
  "toast.no_random": "Impossible. Essaie une autre ambiance.",
  "toast.no_random_dec": "Impossible d'accorder la machine à remonter.",
  "toast.no_random_global": "Impossible de choisir une station aléatoire",
};

const es = {
  "nav.moods": "Ambientes", "nav.places": "Lugares", "nav.genres": "Géneros",
  "nav.top": "Top Estaciones", "nav.favorites": "Favoritos", "nav.recent": "Recientes",
  "nav.tagline": "Mundo · Radio · 24/7",
  "sidebar.search": "Buscar estación…",
  "sidebar.active_filters": "Filtros activos", "sidebar.clear": "Limpiar",
  "sidebar.powered_by": "Impulsado por Radio Browser",
  "sidebar.footer_note": "Sin anuncios · Sin rastreo · 100k+ estaciones",
  "landing.moods.pre": "¿Cómo estás escuchando?",
  "landing.moods.title": "Elige un ambiente",
  "landing.moods.subtitle":
    "Estanterías de radio en vivo de todo el mundo. Toca una tarjeta para explorar — o dale play para escuchar al instante.",
  "landing.timemachine.pre": "Máquina · del · Tiempo", "landing.timemachine.title": "Rebobina por década",
  "landing.genres.pre": "Todos · los · géneros", "landing.genres.title": "Géneros",
  "landing.genres.subtitle":
    "Todos los géneros de Radio Browser. Toca uno para abrir el muro de estaciones.",
  "landing.places.pre": "Sintoniza el mundo", "landing.places.title": "Elige un país",
  "landing.places.subtitle":
    "Gira el globo. Toca cualquier punto para cargar sus estaciones en vivo.",
  "landing.surprise": "Sorpréndeme",
  "mood.late-night": "Noche Tardía", "mood.morning": "Despertar",
  "mood.workout": "Ejercicio", "mood.focus": "Concentración",
  "mood.party": "Fiesta", "mood.chill": "Chill",
  "mood.discovery": "Descubrimiento", "mood.news": "Noticias & Talk",
  "view.top.pre": "Top · Mundo", "view.top.main": "Estaciones más escuchadas",
  "view.favorites.pre": "Tu · Biblioteca", "view.favorites.main": "Favoritos",
  "view.history.pre": "Recientemente · Escuchadas", "view.history.main": "Historial",
  "view.search.pre": "Búsqueda", "view.search.type": "Escribe para buscar…",
  "view.search.results": "Resultados para",
  "view.mood.pre": "Ambiente", "view.decade.pre": "Máquina · del · Tiempo",
  "view.decade.suffix": "Radio",
  "view.filter.pre": "Estaciones", "view.back": "Volver a",
  "view.tuning": "Ajustando frecuencias…",
  "view.stations": "estación", "view.stations_plural": "estaciones",
  "empty.favorites.t": "Sin favoritos", "empty.favorites.s": "Toca el corazón para guardar.",
  "empty.history.t": "Nada reproducido", "empty.history.s": "Tus estaciones aparecerán aquí.",
  "empty.search.t": "Escribe para buscar", "empty.search.s": "Busca por nombre en el sidebar.",
  "empty.filter.t": "Sin coincidencias", "empty.filter.s": "Prueba otro país, tag o idioma.",
  "empty.mood.t": "Sin estaciones", "empty.mood.s": "Prueba otro ambiente o Lugares.",
  "empty.decade.t": "Sin estaciones", "empty.decade.s": "Prueba otra década.",
  "empty.top.t": "Sin datos", "empty.top.s": "Radio Browser podría estar caído.",
  "player.idle": "Inactivo", "player.pick": "Elige una estación",
  "player.on_air": "En Vivo", "player.paused": "Pausado", "player.tuning": "Ajustando…",
  "player.rec": "Grab", "player.eq": "EQ", "player.sleep": "Dormir",
  "player.alarm": "Alarma", "player.share": "Compartir", "player.fav": "Fav",
  "eq.title": "Ecualizador", "eq.subtitle": "5 bandas · ±12dB",
  "sleep.title": "Temporizador de sueño", "sleep.subtitle": "Fade · luego · stop",
  "sleep.running": "En curso", "sleep.cancel": "Cancelar",
  "sleep.min": "min", "sleep.custom": "Personalizado (min)", "sleep.start": "Iniciar",
  "sleep.ended": "Temporizador terminado · buenas noches",
  "alarm.title": "Despertador", "alarm.subtitle": "Despierta · con radio",
  "alarm.time": "Hora", "alarm.station": "Estación",
  "alarm.station.current": "Estación actual",
  "alarm.station.pick_first": "Reproduce una estación y luego configura",
  "alarm.set": "Poner alarma", "alarm.cancel": "Cancelar alarma",
  "alarm.next": "Próxima alarma", "alarm.ringing": "Alarma · a despertar",
  "alarm.set_toast": "Alarma programada para {time}",
  "stats.pre": "Tu · Mapa · de Escucha", "stats.title": "Escuchaste",
  "stats.countries": "países este mes",
  "stats.no_data": "Tu mapa aparecerá tras algunas escuchas.",
  "passport.title": "Pasaporte Voix", "passport.subtitle": "Tu tarjeta mensual de escucha",
  "passport.open": "Mi pasaporte", "passport.id": "ID",
  "passport.hours_label": "Escuchaste", "passport.hours_of_radio": "de radio del mundo",
  "passport.top_countries": "Top países", "passport.fav_mood": "Ambiente favorito",
  "passport.plays": "Escuchas", "passport.countries": "Países", "passport.favorites": "Favoritos",
  "passport.download": "Descargar", "passport.share": "Compartir",
  "passport.exporting": "Exportando…", "passport.downloaded": "Pasaporte guardado",
  "passport.export_failed": "Falló la exportación",
  "passport.empty.title": "Aún sin pasaporte",
  "passport.empty.subtitle": "Reproduce algunas estaciones para desbloquear tu primer pasaporte mensual.",
  "toast.added_fav": "Añadido a favoritos", "toast.removed_fav": "Quitado de favoritos",
  "toast.share_copied": "Enlace copiado", "toast.rec_started": "Grabación iniciada",
  "toast.rec_saved": "Grabación guardada", "toast.rec_no_station": "Reproduce primero una estación",
  "toast.rec_unsupported": "Grabación no soportada", "toast.rec_failed": "Fallo al grabar",
  "toast.stream_fail": "No se pudo iniciar el flujo. Cargando…",
  "toast.no_url": "Sin URL de streaming",
  "toast.disconnected": "Flujo desconectado. Prueba otra.",
  "toast.no_random": "No se pudo. Prueba otro ambiente.",
  "toast.no_random_dec": "No se pudo sintonizar la máquina.",
  "toast.no_random_global": "No se pudo elegir aleatorio",
};

const pt = {
  "nav.moods": "Climas", "nav.places": "Lugares", "nav.genres": "Gêneros",
  "nav.top": "Top Estações", "nav.favorites": "Favoritos", "nav.recent": "Recentes",
  "nav.tagline": "Mundo · Rádio · 24/7",
  "sidebar.search": "Pesquisar estação…",
  "sidebar.active_filters": "Filtros ativos", "sidebar.clear": "Limpar",
  "sidebar.powered_by": "Feito com Radio Browser",
  "sidebar.footer_note": "Sem anúncios · Sem rastreamento · 100k+ estações",
  "landing.moods.pre": "Como está a ouvir?",
  "landing.moods.title": "Escolha um clima",
  "landing.moods.subtitle":
    "Prateleiras curadas de rádio ao vivo do mundo todo. Toque para explorar — ou play para ouvir imediatamente.",
  "landing.timemachine.pre": "Máquina · do · Tempo", "landing.timemachine.title": "Volte por década",
  "landing.genres.pre": "Todos · os · gêneros", "landing.genres.title": "Gêneros",
  "landing.genres.subtitle":
    "Todos os gêneros do Radio Browser. Toque para abrir o mural de estações.",
  "landing.places.pre": "Sintonize o mundo", "landing.places.title": "Escolha um país",
  "landing.places.subtitle":
    "Gire o globo. Toque em qualquer ponto para carregar suas estações ao vivo.",
  "landing.surprise": "Surpreenda-me",
  "mood.late-night": "Madrugada", "mood.morning": "Manhã",
  "mood.workout": "Treino", "mood.focus": "Foco",
  "mood.party": "Festa", "mood.chill": "Chill",
  "mood.discovery": "Descoberta", "mood.news": "Notícias & Talk",
  "view.top.pre": "Top · Mundo", "view.top.main": "Estações mais ouvidas",
  "view.favorites.pre": "Sua · Biblioteca", "view.favorites.main": "Favoritos",
  "view.history.pre": "Recentemente · Ouvidas", "view.history.main": "Histórico",
  "view.search.pre": "Busca", "view.search.type": "Digite para buscar…",
  "view.search.results": "Resultados para",
  "view.mood.pre": "Clima", "view.decade.pre": "Máquina · do · Tempo",
  "view.decade.suffix": "Rádio",
  "view.filter.pre": "Estações", "view.back": "Voltar para",
  "view.tuning": "Sintonizando frequências…",
  "view.stations": "estação", "view.stations_plural": "estações",
  "empty.favorites.t": "Sem favoritos", "empty.favorites.s": "Toque o coração para salvar.",
  "empty.history.t": "Nada reproduzido", "empty.history.s": "Suas estações aparecerão aqui.",
  "empty.search.t": "Digite para buscar", "empty.search.s": "Busque por nome na barra lateral.",
  "empty.filter.t": "Sem correspondências", "empty.filter.s": "Tente outro país, tag ou idioma.",
  "empty.mood.t": "Sem estações", "empty.mood.s": "Tente outro clima ou Lugares.",
  "empty.decade.t": "Sem estações", "empty.decade.s": "Tente outra década.",
  "empty.top.t": "Sem dados", "empty.top.s": "Radio Browser pode estar fora.",
  "player.idle": "Inativo", "player.pick": "Escolha uma estação",
  "player.on_air": "No Ar", "player.paused": "Pausado", "player.tuning": "Sintonizando…",
  "player.rec": "Grav", "player.eq": "EQ", "player.sleep": "Dormir",
  "player.alarm": "Alarme", "player.share": "Compartilhar", "player.fav": "Fav",
  "eq.title": "Equalizador", "eq.subtitle": "5 bandas · ±12dB",
  "sleep.title": "Temporizador", "sleep.subtitle": "Fade · e · para",
  "sleep.running": "Em curso", "sleep.cancel": "Cancelar",
  "sleep.min": "min", "sleep.custom": "Personalizado (min)", "sleep.start": "Iniciar",
  "sleep.ended": "Temporizador terminado · boa noite",
  "alarm.title": "Despertador", "alarm.subtitle": "Acorde · com rádio",
  "alarm.time": "Hora", "alarm.station": "Estação",
  "alarm.station.current": "Estação atual",
  "alarm.station.pick_first": "Toque uma estação e depois configure",
  "alarm.set": "Definir alarme", "alarm.cancel": "Cancelar alarme",
  "alarm.next": "Próximo alarme", "alarm.ringing": "Alarme · hora de acordar",
  "alarm.set_toast": "Alarme às {time}",
  "stats.pre": "Seu · Mapa · de Escuta", "stats.title": "Você ouviu",
  "stats.countries": "países este mês",
  "stats.no_data": "Seu mapa aparecerá após algumas escutas.",
  "passport.title": "Passaporte Voix", "passport.subtitle": "Seu cartão mensal de escuta",
  "passport.open": "Meu passaporte", "passport.id": "ID",
  "passport.hours_label": "Você ouviu", "passport.hours_of_radio": "de rádio mundial",
  "passport.top_countries": "Top países", "passport.fav_mood": "Clima favorito",
  "passport.plays": "Escutas", "passport.countries": "Países", "passport.favorites": "Favoritos",
  "passport.download": "Baixar", "passport.share": "Compartilhar",
  "passport.exporting": "Exportando…", "passport.downloaded": "Passaporte salvo",
  "passport.export_failed": "Falha na exportação",
  "passport.empty.title": "Ainda sem passaporte",
  "passport.empty.subtitle": "Toque algumas estações para desbloquear seu primeiro passaporte mensal.",
  "toast.added_fav": "Adicionado aos favoritos", "toast.removed_fav": "Removido dos favoritos",
  "toast.share_copied": "Link copiado", "toast.rec_started": "Gravação iniciada",
  "toast.rec_saved": "Gravação salva", "toast.rec_no_station": "Toque uma estação primeiro",
  "toast.rec_unsupported": "Gravação não suportada", "toast.rec_failed": "Falha ao gravar",
  "toast.stream_fail": "Falha ao iniciar o stream. Carregando…",
  "toast.no_url": "Sem URL de streaming",
  "toast.disconnected": "Stream desconectado. Tente outra.",
  "toast.no_random": "Não deu. Tente outro clima.",
  "toast.no_random_dec": "Máquina do tempo indisponível.",
  "toast.no_random_global": "Não foi possível escolher aleatório",
};

export const DICTS = { en, fr, es, pt };
